<template>
  <svg width="39px" height="30px" viewBox="0 0 39 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <!-- Generator: Sketch 61 (89581) - https://sketch.com -->
      <title>Combined Shape</title>
      <desc>Created with Sketch.</desc>
      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Desktop-HD" transform="translate(-282.000000, -566.000000)" fill="#000000" fill-rule="nonzero">
              <g id="Group-4" transform="translate(188.000000, 550.000000)">
                  <g id="Group-3" transform="translate(82.000000, 0.000000)">
                      <path d="M50.5714286,16 L50.5714286,46 L12,46 L12,16 L50.5714286,16 Z M42,28.8571429 L37.7142857,28.8571429 L37.7142857,24.5714286 L42,24.5714286 L42,20.2857143 L20.5714286,20.2857143 L20.5714286,24.5714286 L16.2857143,24.5714286 L16.2857143,41.7142857 L46.2857143,41.7142857 L46.2857143,24.5714286 L42,24.5714286 L42,28.8571429 Z M33.4285714,33.1428571 L33.4285714,37.4285714 L29.1428571,37.4285714 L29.1428571,33.1428571 L33.4285714,33.1428571 Z M29.1428571,28.8571429 L29.1428571,33.1428571 L24.8571429,33.1428571 L24.8571429,28.8571429 L29.1428571,28.8571429 Z M37.7142857,28.8571429 L37.7142857,33.1428571 L33.4285714,33.1428571 L33.4285714,28.8571429 L37.7142857,28.8571429 Z M24.8571429,24.5714286 L24.8571429,28.8571429 L20.5714286,28.8571429 L20.5714286,24.5714286 L24.8571429,24.5714286 Z" id="Combined-Shape"></path>
                  </g>
              </g>
          </g>
      </g>
  </svg>
</template>

<script>
  export default {
    name: 'Email',
    data() {
      return {};
    },
  }
</script>